__turbopack_context__.v({
  "arrowContainer": "wKz9wa_arrowContainer",
  "arrowDown": "wKz9wa_arrowDown",
  "bounce": "wKz9wa_bounce",
  "imageWrapper": "wKz9wa_imageWrapper",
  "linkStyles": "wKz9wa_linkStyles",
  "miladiDateStyels": "wKz9wa_miladiDateStyels",
  "noneLink": "wKz9wa_noneLink",
  "shamsiDateStyles": "wKz9wa_shamsiDateStyles",
  "verticalLine": "wKz9wa_verticalLine",
  "yearItemSmall": "wKz9wa_yearItemSmall",
});
